export const PROVIDER_TEST_IDS = {
  PAGE: 'provider-page',
  SEARCH_NAME: 'provider-search-name',
  SEARCH_PARTNER_ID: 'provider-search-partner-id',
  ADD_BTN: 'provider-add-btn',
  STATUS_FILTER: 'provider-status-filter',
  TABLE: 'provider-table',
  TABLE_ROW: (id: string) => `provider-table-row-${id}`,
  COL_NAME: (id: string) => `provider-col-name-${id}`,
  COL_PARTNER_ID: (id: string) => `provider-col-partner-id-${id}`,
  COL_SERVER: (id: string) => `provider-col-server-${id}`,
  COL_PROFILE: (id: string) => `provider-col-profile-${id}`,
  COL_PROVIDER_ID: (id: string) => `provider-col-provider-id-${id}`,
  COL_VDI_VERSION: (id: string) => `provider-col-vdi-version-${id}`,
  COL_SYNC_VDI: (id: string) => `provider-col-sync-vdi-${id}`,
  COL_CREATED_ON: (id: string) => `provider-col-created-on-${id}`,
  COL_UPDATED_ON: (id: string) => `provider-col-updated-on-${id}`,
  COL_VIEW_BTN: (id: string) => `provider-col-view-btn-${id}`,
  COL_REACTIVATE_BTN: (id: string) => `provider-col-reactivate-btn-${id}`,

  // ── ViewProvider ───────────────────────────────────────────────────
  VIEW_PAGE: 'provider-view-page',
  VIEW_EDIT_BTN: 'provider-view-edit-btn',
  VIEW_DELETE_BTN: 'provider-view-delete-btn',
  VIEW_BACK_BTN: 'provider-view-back-btn',
  VIEW_DELETE_MODAL_CONFIRM_BTN: 'provider-view-delete-modal-confirm-btn',

  // ── CrudProvider ───────────────────────────────────────────────────
  CRUD_PAGE: 'provider-crud-page',
  CRUD_CLOSE_BTN: 'provider-crud-close-btn',
  CRUD_SERVER_SELECT: 'provider-crud-server-select',
  CRUD_PROFILE_INPUT: 'provider-crud-profile-input',
  CRUD_NAME_INPUT: 'provider-crud-name-input',
  CRUD_PARTNER_ID_INPUT: 'provider-crud-partner-id-input',
  CRUD_VDI_V1_BTN: 'provider-crud-vdi-v1-btn',
  CRUD_VDI_V2_BTN: 'provider-crud-vdi-v2-btn',
  CRUD_SYNC_TOGGLE: 'provider-crud-sync-toggle',
  CRUD_RESET_BTN: 'provider-crud-reset-btn',
  CRUD_CANCEL_BTN: 'provider-crud-cancel-btn',
  CRUD_SAVE_BTN: 'provider-crud-save-btn',
  CRUD_CONFIRM_MODAL_CANCEL_BTN: 'provider-crud-confirm-modal-cancel-btn',
  CRUD_CONFIRM_MODAL_UPDATE_BTN: 'provider-crud-confirm-modal-update-btn',

  // ── ProviderConfiguration ──────────────────────────────────────────
  CRUD_CONFIG_MODE_SWITCHER: 'provider-crud-config-mode-switcher',
  CRUD_FORK_TRANSACTION_TOGGLE: 'provider-crud-fork-transaction-toggle',
  CRUD_RECONCILIATION_TOGGLE: 'provider-crud-reconciliation-toggle',

  // ── MMS Config Section ─────────────────────────────────────────────
  CRUD_MMS_ACCORDION: 'provider-crud-mms-accordion',
  CRUD_MMS_HOST_INPUT: 'provider-crud-mms-host-input',
  CRUD_MMS_AUTH_TYPE_SELECT: 'provider-crud-mms-auth-type-select',
  CRUD_MMS_VERSION_SELECT: 'provider-crud-mms-version-select',
  CRUD_MMS_GET_STATE_TOGGLE: 'provider-crud-mms-get-state-toggle',
  CRUD_MMS_XML_VERSION_INPUT: 'provider-crud-mms-xml-version-input',
  CRUD_MMS_PROVIDER_ID_INPUT: 'provider-crud-mms-provider-id-input',
  CRUD_MMS_APP_ID_INPUT: 'provider-crud-mms-app-id-input',
  CRUD_MMS_APP_VERSION_INPUT: 'provider-crud-mms-app-version-input',
  CRUD_MMS_VDI_TYPES_PREFIX: 'provider-crud-mms-vdi',

  // ── VMS Config Section ─────────────────────────────────────────────
  CRUD_VMS_ACCORDION: 'provider-crud-vms-accordion',
  CRUD_VMS_HOST_INPUT: 'provider-crud-vms-host-input',
  CRUD_VMS_AUTH_TYPE_SELECT: 'provider-crud-vms-auth-type-select',
  CRUD_VMS_VERSION_SELECT: 'provider-crud-vms-version-select',
  CRUD_VMS_GET_STATE_TOGGLE: 'provider-crud-vms-get-state-toggle',
  CRUD_VMS_VDI_TYPES_PREFIX: 'provider-crud-vms-vdi',
  CRUD_VMS_XML_VERSION_INPUT: 'provider-crud-vms-xml-version-input',
  CRUD_VMS_PROVIDER_ID_INPUT: 'provider-crud-vms-provider-id-input',
  CRUD_VMS_APP_ID_INPUT: 'provider-crud-vms-app-id-input',
  CRUD_VMS_APP_VERSION_INPUT: 'provider-crud-vms-app-version-input',

  // ── CLIENTS Config Section ─────────────────────────────────────────
  CRUD_CLIENTS_ACCORDION: 'provider-crud-clients-accordion',
  CRUD_CLIENTS_HOST_INPUT: 'provider-crud-clients-host-input',
  CRUD_CLIENTS_AUTH_TYPE_SELECT: 'provider-crud-clients-auth-type-select',
  CRUD_CLIENTS_VERSION_SELECT: 'provider-crud-clients-version-select',
  CRUD_CLIENTS_GET_STATE_TOGGLE: 'provider-crud-clients-get-state-toggle',
  CRUD_CLIENTS_VDI_TYPES_PREFIX: 'provider-crud-clients-vdi',

  // ── ALERTS Config Section ──────────────────────────────────────────
  CRUD_ALERTS_ACCORDION: 'provider-crud-alerts-accordion',
  CRUD_ALERTS_SUB_HEADER: (key: string) =>
    `provider-crud-alerts-${key.toLowerCase()}-header`,
  CRUD_ALERTS_SUB_TOGGLE: (key: string) =>
    `provider-crud-alerts-${key.toLowerCase()}-toggle`,
  CRUD_ALERTS_SUB_HOST: (key: string) =>
    `provider-crud-alerts-${key.toLowerCase()}-host`,
  CRUD_ALERTS_SUB_AUTH_TYPE: (key: string) =>
    `provider-crud-alerts-${key.toLowerCase()}-auth-type`,
  CRUD_ALERTS_SUB_GET_STATE: (key: string) =>
    `provider-crud-alerts-${key.toLowerCase()}-get-state`,

  // ── SMART_COOLERS Config Section ───────────────────────────────────
  CRUD_SC_ACCORDION: 'provider-crud-sc-accordion',
  CRUD_SC_SUB_HEADER: (key: string) =>
    `provider-crud-sc-${key.toLowerCase()}-header`,
  CRUD_SC_SUB_TOGGLE: (key: string) =>
    `provider-crud-sc-${key.toLowerCase()}-toggle`,
  CRUD_SC_SUB_HOST: (key: string) =>
    `provider-crud-sc-${key.toLowerCase()}-host`,
  CRUD_SC_SUB_AUTH_TYPE: (key: string) =>
    `provider-crud-sc-${key.toLowerCase()}-auth-type`,
  CRUD_SC_SUB_GET_STATE: (key: string) =>
    `provider-crud-sc-${key.toLowerCase()}-get-state`,
} as const;
